<div class="global-filter">
    <div class="global-filter__head">
        <!-- <div class="global-filter__head-text">
            <p class="global-filter__title">Global filter conditions</p>
            <p class="global-filter__description">
                These conditions apply to every filter below and can be used to narrow the dataset before any page or tab filters are applied.
            </p>
        </div> -->
        <button type="button" class="global-filter__add-btn" (click)="addCondition()">
            <mat-icon aria-hidden="true">add</mat-icon>
            <span>Add condition</span>
        </button>
    </div>

    <ng-container *ngIf="conditions.length">
        <div class="global-filter__chips">
            <ng-container *ngFor="let condition of conditions">
                <span class="global-filter__chip"
                    [class.global-filter__chip--active]="condition.id === activeConditionId"
                    *ngIf="getColumnLabel(condition)">
                <span [attr.aria-pressed]="condition.id === activeConditionId" (click)="selectCondition(condition)">
                    {{ getColumnLabel(condition) }}
                </span>
                <button type="button" class="global-filter__chip-remove" aria-label="Remove condition"
                    (click)="removeCondition(condition); $event.stopPropagation()">
                    <mat-icon aria-hidden="true">close</mat-icon>
                </button>
                </span>
            </ng-container>
        </div>
    </ng-container>


    <div class="global-filter__panel" *ngIf="activeCondition as condition">
        <div class="global-filter__panel-head" *ngIf="getColumnLabel(condition)">
            <span class="global-filter__panel-title">Condition: {{ getColumnLabel(condition) }}</span>
            <span class="global-filter__panel-count">{{ condition.selectedValues.length }} selected values</span>
        </div>

        <div class="global-filter__field-row">
            <div class="global-filter__field" *ngIf="mode === 'table'">
                <label class="global-filter__field-label">Table</label>
                <mat-select class="global-filter__select" placeholder="Select table" [ngModel]="condition.tableKey"
                    (ngModelChange)="onTableSelected(condition, $event)">
                    <mat-option *ngFor="let table of tableOptions" [value]="table.value">{{ table.label }}</mat-option>
                </mat-select>
            </div>

            <div class="global-filter__field">
                <label class="global-filter__field-label">Column</label>
                <mat-select class="global-filter__select" placeholder="Select column" [ngModel]="condition.columnKey"
                    [disabled]="mode === 'table' && !condition.tableKey"
                    (ngModelChange)="onColumnSelected(condition, $event)">
                    <mat-option *ngFor="let option of condition.availableColumns" [value]="option.key">{{ option.label }}</mat-option>
                </mat-select>
            </div>
        </div>

        <ng-container *ngIf="condition.columnKey">
            <input type="text" class="global-filter__search" placeholder="Search values..." [ngModel]="condition.searchTerm"
                (ngModelChange)="onSearchChanged(condition, $event)" />

            <div class="global-filter__values">
                <p class="global-filter__value-loading" *ngIf="condition.valuesLoading">Loading values...</p>
                <cdk-virtual-scroll-viewport class="global-filter__viewport" itemSize="34"
                    *ngIf="!condition.valuesLoading && condition.filteredValues.length">
                    <label class="global-filter__value-item"
                        *cdkVirtualFor="let value of condition.filteredValues; trackBy: trackValue">
                        <input type="checkbox" [checked]="isValueSelected(condition, value)"
                            (change)="toggleValue(condition, value)" />
                        <span>{{ value }}</span>
                    </label>
                </cdk-virtual-scroll-viewport>
                <p class="global-filter__value-empty"
                    *ngIf="!condition.valuesLoading && !condition.filteredValues.length">
                    No values found.
                </p>
            </div>

            <div class="global-filter__footer">
         <span class="global-filter__footer-count" *ngIf="activeCondition as condition">
             {{ condition.selectedValues.length }} of {{ condition.availableValues.length }} values selected
         </span>
         <div class="global-filter__footer-actions">
             <button type="button" class="global-filter__btn global-filter__btn--secondary" (click)="onCancel()">Cancel</button>
             <button type="button" class="global-filter__btn global-filter__btn--primary"
                [disabled]="!canApply" (click)="onApply()">Apply</button>
         </div>
     </div>
        </ng-container>
    </div>
</div>
